import { CookieStorage } from "cookie-storage";

enum CookiesKeys {
  TokenKey = "tokenKey",
  Id = "Id",
  User = "User",
  Password = "Password",
  Tenant= "Tenant",
  Modules= "Modules",
  Rol="Rol",
  RolId="RolId",
  UserInfo="userInfo"


}
export const cookieStorage = new CookieStorage({
  domain: process.env.REACT_APP_DOMAIN_COOKIE,
  path: "/"
});

export const cookieAvailable = (cookieKey: string, cookieValue: string) => {
  return cookieStorage.getItem(cookieKey) === cookieValue;
};

export default CookiesKeys;
